import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { noteRound } from "../../../../util/DoubleUtil";
import TableCellCustom from "../../../UI/TableCellCustom";
import TableCellLeftCustom from "../../../UI/TableCellLeftCustom";
import TableCellRightCustom from "../../../UI/TableCellRightCustom";

// ─── helpers ────────────────────────────────────────────────────────────────

const BIMESTRES = [1, 2, 3, 4];

const safeNote = (obj) => (obj?.nota ? noteRound(obj.nota) : "--");

const safeVal = (val) => val ?? "--";

const calcCargaHoraria = (bnb) =>
  BIMESTRES.reduce((acc, n) => acc + (bnb[`totalAulas${n}`] ?? 0), 0);

// ─── sub-componente ──────────────────────────────────────────────────────────

const BimestreCells = ({ nota, faltas, ausencia }) => (
  <>
    <TableCellLeftCustom>{safeNote(nota)}</TableCellLeftCustom>
    <TableCell>{safeVal(faltas)}</TableCell>
    <TableCellRightCustom>{safeVal(ausencia)}</TableCellRightCustom>
  </>
);

// ─── componente principal ────────────────────────────────────────────────────

const titleStyle = {
  textAlign: "center",
  textDecoration: "underline",
};

export default function RelatorioBoletimNotaBimestreWeb({ boletimEscolar }) {
  const { bnotaBimestres } = boletimEscolar;

  return (
    <>
      <Typography variant="h6" style={titleStyle}>
        Base Comum
      </Typography>

      <Table size="small" aria-label="boletim escolar – notas por bimestre">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2}>Disciplinas</TableCell>

            {BIMESTRES.map((n) => (
              <TableCellCustom key={n} colSpan={3}>
                {n}º Bim.
              </TableCellCustom>
            ))}

            <TableCell rowSpan={2}>5º Con.</TableCell>
            <TableCell rowSpan={2}>Rec. Int.</TableCell>
            <TableCell rowSpan={2}>Média Final</TableCell>
            <TableCell rowSpan={2}>C. H.</TableCell>
            <TableCell rowSpan={2}>Freq. (%)</TableCell>
          </TableRow>

          <TableRow>
            {BIMESTRES.map((n) => (
              <React.Fragment key={n}>
                <TableCellLeftCustom>Nota</TableCellLeftCustom>
                <TableCell>Falta</TableCell>
                {n < 4 ? (
                  <TableCell>AC</TableCell>
                ) : (
                  <TableCellRightCustom>AC</TableCellRightCustom>
                )}
              </React.Fragment>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {bnotaBimestres.map((bnb, index) => (
            <TableRow key={bnb.tdp?.disciplina?.id ?? index}>
              <TableCell>{bnb.tdp.disciplina.descricao}</TableCell>

              {BIMESTRES.map((n) => (
                <BimestreCells
                  key={n}
                  nota={bnb[`mediaBimestral${n}`]}
                  faltas={bnb[`totalFaltas${n}`]}
                  ausencia={bnb[`ausenciaCompensada${n}`]}
                />
              ))}

              <TableCell>{safeNote(bnb.quintoConceito)}</TableCell>
              <TableCell>{safeNote(bnb.recuperacaoIntensiva)}</TableCell>
              <TableCell>{safeNote(bnb.mediaFinal)}</TableCell>
              <TableCell>{calcCargaHoraria(bnb)}</TableCell>
              <TableCell>{bnb.frequencia}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
